export const appPluginsOrder = ['heyApi', 'auth', 'pinia', 'router']
